export default {
  news: [],
  count: 0
};
